import React from "react";

const CalciteRadioButton = ({ checked, disabled, guid, hidden, name, required, scale, value, onChange }) => {
  const buttonRef = React.useRef(null);

  React.useEffect(() => {
    const button = buttonRef.current;

    const onChangeHandler = onChange;
    if (onChangeHandler) button.addEventListener("calciteRadioButtonChange", onChangeHandler);

    return () => {
      if (onChangeHandler) button.removeEventListener("calciteRadioButtonChange", onChangeHandler);
    };
  });

  return (
    <calcite-radio-button
      ref={buttonRef}
      checked={checked || undefined}
      disabled={disabled || undefined}
      guid={guid || undefined}
      hidden={hidden || undefined}
      name={name || undefined}
      required={required || undefined}
      scale={scale || undefined}
      value={value || undefined}
    ></calcite-radio-button>
  );
};

export default CalciteRadioButton;
